import React from 'react';

import { Typography } from '@mui/material';
import { capitalCase } from 'change-case';
import { useSelectedCommunityCategory } from 'src/hooks';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
  h1: {
    fontSize: 36,
    fontWeight: 700,
  },
  title: {
    color: '#CB3E6D',
    fontWeight: 600,
  },
}));

interface TopTemplatesHeaderProps {
  variant: 'template' | 'workflow';
}

export function TopTemplatesHeader({ variant }: TopTemplatesHeaderProps): JSX.Element {
  const { classes } = useStyles();
  const { selectedCategory } = useSelectedCommunityCategory();
  const templateText = variant === 'template' ? 'TEMPLATES' : 'WORKFLOWS';
  const topText = selectedCategory
    ? `TOP ${selectedCategory.title.toUpperCase().trim()} ${templateText}`
    : `TOP ${templateText}`;

  return (
    <div className={classes.container}>
      <Typography className={classes.title}>{topText}</Typography>
      <Typography className={classes.h1}>{`Most Copied ${capitalCase(
        templateText
      )} 👌`}</Typography>
    </div>
  );
}
